AutoInsertionView = require 'app/scripts/views/internal/autocomplete/auto-insertion-view'
CompleterUtil = require 'app/scripts/views/internal/autocomplete/completer-util'
CheckItemMenuView = require 'app/scripts/views/checklist/check-item-menu-view'
Dates = require 'app/scripts/lib/dates'
{ dontUpsell } = require '@trello/config'
DueDateHelpers = require 'app/scripts/views/internal/due-date-helpers'
EditableView = require 'app/scripts/views/internal/editable-view'
{ featureFlagClient } = require '@trello/feature-flag-client'
{ forNamespace } = require 'app/common/lib/util/i18n'
getExperiment = require 'app/scripts/lib/experiments/simple-test'
moment = require 'moment'
{ OrganizationFeature } = require '@trello/product-features'
PopOver = require 'app/scripts/views/lib/pop-over'
TFM = require 'app/scripts/lib/markdown/tfm'
Util = require 'app/scripts/lib/util'
friendlyLinks = require 'app/scripts/views/internal/friendly-links'
{ mixin } = require 'app/scripts/lib/mixin_DO_NOT_USE'
{ track, trackUe, Verb, Noun } = require '@trello/analytics'
t = require('app/scripts/views/internal/teacup-with-helpers')('checklist_item')
{ toggleAssignPopoverBeta, toggleAssignPopoverV2, replaceAssignInputValue } = require 'app/scripts/views/checklist/toggle-assign-popover'
{ toggleDatePopoverBeta, toggleDatePopoverV2, replaceDueInputValue } = require 'app/scripts/views/checklist/toggle-date-popover'
{ toggleUpsellAdvancedChecklist } = require 'app/scripts/views/checklist/upsell-advanced-checklist'
{ toggleClearPopover } = require 'app/scripts/views/checklist/toggle-clear-popover'
urls = require 'app/scripts/controller/urls'
memberAvatarTemplate = require 'app/scripts/views/templates/member_avatar'
{ avatarDomain } = require '@trello/config'
Layout = require 'app/scripts/views/lib/layout'
{ getAssigneeUsername, getDueDate, startsWithMention, endsWithDate, trackNameChange, trackNameRender } = require './check-item-name'
{ hasAdvancedChecklistsBeta, hasAdvancedChecklistsV2, hasUpsell, shouldShowEditModeButtons, hasAdvancedChecklists } = require './has-advanced-checklists'

viewTitle = forNamespace('view title')

template = t.renderable ({ editable, showSetDueDateButton, showAssignButton, showAssignBadge, showDueDateBadge }) ->
  t.div '.checklist-item-checkbox', { class: t.classify({ enabled: editable, 'js-toggle-checklist-item': editable }) }, ->
    t.icon 'check', { class: 'checklist-item-checkbox-check' }

  t.div '.checklist-item-details.non-empty.js-checkitem', { class: t.classify({ editable }), attr: 'name' }, ->
    t.div '.checklist-item-row.js-checkitem-row.current', ->
      t.div '.checklist-item-text-and-controls.hide-on-edit', ->
        t.span '.checklist-item-details-text.markeddown.js-checkitem-name'
        t.div '.checklist-item-controls', ->
          if showDueDateBadge
            t.span '.checklist-item-due.js-checklist-item-due'
          if showAssignBadge
            t.span '.checklist-item-assignee.js-checklist-item-assignee'
          if editable
            t.div '.checklist-item-menu.js-open-menu', ->
              t.span '.icon-sm.icon-overflow-menu-horizontal'

      if editable
        t.div '.edit.options-menu', { class: t.classify({ assign: showAssignButton, due: showSetDueDateButton }) }, ->
          t.textarea '.field.full.single-line.js-checkitem-input', { type: 'text' }

    if editable
      t.p '.edits-warning.quiet', ->
        t.format 'you-have-unsaved-edits-on-this-field'
        t.text ' '
        t.a '.js-view-edits', { href: '#' }, ->
          t.format 'view-edits'
        t.text " - "
        t.a '.js-discard-edits', { href: '#' }, ->
          t.format 'discard'

assigneeTemplate = t.renderable ({ member }, canEdit, advancedChecklistsEnabled, showUpsell) ->
  if advancedChecklistsEnabled || member || showUpsell
    if canEdit
      showClear = member && !advancedChecklistsEnabled

      t.button '.subtle', {
        class: t.classify({
          'js-open-assign-selector-no-edit': !showClear
          'js-clear-assignment': showClear
        }),
      }, ->
        if member
          t.div '.member.m-member-mod-24', ->
            memberAvatarTemplate(member)
        else
          t.icon 'add-member'
    else if member
      t.span '.disabled', ->
        t.div '.member.m-member-mod-24', ->
          memberAvatarTemplate(member)

dueTemplate = t.renderable (due, className, canEdit, advancedChecklistsEnabled, showUpsell) ->
  if advancedChecklistsEnabled || due || showUpsell
    if canEdit
      showClear = due && !advancedChecklistsEnabled

      t.button ".subtle.#{ className }", {
        class: t.classify({
          'js-open-due-selector-no-edit': !showClear,
          'js-clear-due': showClear
        })
      }, ->
        t.icon 'clock'
        if due
          t.text due
    else if due
      t.span '.disabled', { class: className }, ->
        t.icon 'clock'
        t.text due

module.exports = mixin AutoInsertionView, CompleterUtil, class CheckItemView extends EditableView
  className: 'checklist-item'

  allowNewlines: false

  initialize: ->
    @listenTo @model,
      'change:name': ->
        @renderName()
        @renderAssignee()
        @renderDue()
      'change:state': ->
        @renderState()
        @renderDue()
      'change:due': ->
        @renderDue()
      'change:idMember': ->
        @renderAssignee()
    super

  events:
    'keyup .js-checkitem-input': 'keyAutoMention'
    'click .js-toggle-checklist-item': 'toggleState'

    'click .js-open-menu': 'openMenu'

    'click .js-open-mention-selector': 'commentMentionMember'
    'click .js-open-emoji-selector': 'commentAddEmoji'
    'movecheckitem': 'moveCheckItem'

    # Advanced Checklists
    'click .js-open-assign-selector:not([disabled])': (e) ->
      @assignUpsellOrPopover(e, {
        setValue: (value) => replaceAssignInputValue(@el.querySelector('.js-checkitem-input'), value)
        getInitialValue: => @el.querySelector('.js-checkitem-input').value
        trackingMethod: 'by clicking member button in edit checkitem view'
      })

    'click .js-open-assign-selector-no-edit:not([disabled])': (e) ->
      @assignUpsellOrPopover(e, {
        setValue: (name) => @_setName(name, 'by clicking member in assign member popover')
        getInitialValue: => @model.get('name')
        trackingMethod: 'by clicking member button in checkitem view'
      })

    'click .js-open-due-selector:not([disabled])': (e) ->
      @dueDateUpsellOrPopover(e, {
        setValue: (value) => replaceDueInputValue(@el.querySelector('.js-checkitem-input'), value)
        getInitialValue: => @el.querySelector('.js-checkitem-input').value
        trackingMethod: 'by clicking due date button in edit checkitem view'
      })

    'click .js-open-due-selector-no-edit:not([disabled])': (e) ->
      @dueDateUpsellOrPopover(e, {
        setValue: (name) => @_setName(name, 'by clicking a submit button in due date picker')
        getInitialValue: => @model.get('name')
        trackingMethod: 'by clicking due date badge in checkitem view'
      })

    'click .js-clear-assignment:not([disabled])': (e) ->
      toggleClearPopover({
        title: viewTitle('assign'),
        clear: => @_setMember(null)
      })(e)

    'click .js-clear-due:not([disabled])': (e) ->
      toggleClearPopover({
        title: viewTitle('change due date'),
        clear: => @_setDue(null)
      })(e)


  dueDateUpsellOrPopover: (e, { setValue, getInitialValue, trackingMethod, billingUrl }) ->
    if hasAdvancedChecklistsBeta(@model.getBoard()?.getOrganization()?.getProduct())
      toggleDatePopoverBeta({
        title: viewTitle('change due date') + ' (Beta)',
        setValue,
        getInitialValue,
        trackingMethod,
      })(e)
    else if hasAdvancedChecklistsV2(@model.getBoard()?.getOrganization()?.getProduct())
      toggleDatePopoverV2({
        title: viewTitle('change due date'),
        setDate: (date) => @_setDue(date)
        getInitialDate: => @model.get('due')
        trackingMethod,
      })(e)
    else if @_hasUpsell()
      toggleUpsellAdvancedChecklist({
        trackingMethod: 'by clicking due date button in checkitem composer',
        billingUrl: @getBillingUrl()
      })(e)

  assignUpsellOrPopover: (e, { setValue, getInitialValue, trackingMethod }) ->
    if hasAdvancedChecklistsBeta(@model.getBoard()?.getOrganization()?.getProduct())
      toggleAssignPopoverBeta({
        setValue
        getInitialValue
        title: viewTitle('assign') + ' (Beta)'
        getCardMembers: => @model.getCard().memberList.toJSON()
        getBoardMembers: => @model.getBoard().memberList.filterDeactivated(force: true).toJSON()
        trackingMethod
      })(e)
    else if hasAdvancedChecklistsV2(@model.getBoard()?.getOrganization()?.getProduct())
      toggleAssignPopoverV2({
        title: viewTitle('assign') + ' (Beta)'
        getCardMembers: => @model.getCard().memberList.toJSON()
        getBoardMembers: => @model.getBoard().memberList.filterDeactivated(force: true).toJSON()
        trackingMethod,
        getInitialMember: => @model.get('idMember'),
        setMember: (idMember) =>
          @_setMember(idMember)
      })(e)
    else if @_hasUpsell()
      toggleUpsellAdvancedChecklist({
        trackingMethod: 'by clicking member button in checkitem composer',
        billingUrl: @getBillingUrl()
      })(e)

  getCard: -> @model.getCard()

  getBillingUrl: ->
    org = @model.getBoard().getOrganization()
    if org?
      urls.getOrganizationBillingUrl(org)

  advancedCheckItemFromModel: ->
    return {
      name: @model.get('name'),
      validAssigneeUsernames: @model.getBoard().memberList.map((member) -> member.get('username'))
      orgProductNumber: @model.getBoard()?.getOrganization()?.getProduct()
    }

  render: ->
    view = @
    model = @model

    org = @model.getBoard()?.getOrganization()
    product = org?.getProduct()
    editable = @model.editable()

    _hasAdvancedChecklists = hasAdvancedChecklists(product)
    _hasUpsell = @_hasUpsell()
    _shouldShowEditModeButtons = shouldShowEditModeButtons(product, editable, org?)

    @$el.html(
      template({
        showAssignBadge: _hasAdvancedChecklists || _hasUpsell || @model.get('idMember')?
        showDueDateBadge: _hasAdvancedChecklists || _hasUpsell || @model.get('due')?
        showAssignButton: editable && _shouldShowEditModeButtons
        showSetDueDateButton: editable && _shouldShowEditModeButtons
        editable: editable
      })
    )

    @renderAssignee()
    @renderDue()
    @renderName()
    @renderState()
    @recallDrafts()

    trackNameRender(@advancedCheckItemFromModel())

    @

  getTextInput: ->
    @$('.js-checkitem-input')

  getMentionTarget: ->
    @$('.js-open-mention-selector')[0]

  getEmojiTarget: ->
    @$('.js-open-emoji-selector')[0]

  _hasUpsell: ->
    board = @model.getBoard()
    orgIsHidden = board?.hasOrganization() && !board?.getOrganization()?
    hasUpsell(@model.editable(), !orgIsHidden)

  renderName: (e) ->
    name = @model.get('name')

    @$('.js-checkitem-row').data('unmarkeddown', name)

    nameHtml = TFM.checkItems.format(name, { textData: @model.get('nameData') }).output
    $name = @$('.js-checkitem-name')
    $name.empty().append(nameHtml)

    friendlyLinks $name[0], @model.getBoard()
    return

  renderAssignee: ->
    $assignee = @$('.js-checklist-item-assignee')
    if !$assignee.length
      return

    product = @model.getBoard()?.getOrganization()?.getProduct()

    _hasAdvancedChecklists = hasAdvancedChecklists(product)

    predicate =
      # If there is a member in model.get('idMember') we'll always use that
      if (idMember = @model.get('idMember'))?
        (member) -> member.id == idMember
      # If it's not set, we'll fall back to trying to read from the checkitem name
      else if _hasAdvancedChecklists
        assigneeUsername = getAssigneeUsername(@advancedCheckItemFromModel())
        if assigneeUsername?
          (member) -> member.get('username') == assigneeUsername

    member =
      if predicate?
        @model.getBoard().memberList.find(predicate)

    $assignee.html(assigneeTemplate({
      member: member?.toJSON()
    }, @model.editable(), _hasAdvancedChecklists, @_hasUpsell()))
    .toggleClass('unset', !member?)

    @$el.toggleClass('no-assignee', !member?)

    return

  renderDue: ->
    $due = @$('.js-checklist-item-due')

    if !$due.length
      return

    product = @model.getBoard()?.getOrganization()?.getProduct()

    _hasAdvancedChecklists = hasAdvancedChecklists(product)

    dueAttribute = @model.get('due')
    due =
      # If there is a due date in the model.get('due') we'll always use that
      dueAttribute ?
      # If it's not set, we'll fall back to trying to read from the checkitem name
      if _hasAdvancedChecklists
        getDueDate(@advancedCheckItemFromModel())

    dueText = due && Dates.toDateString(due)

    className =
      if due
        complete = @model.get('state') == 'complete'
        if dueAttribute?
          DueDateHelpers.classForDueDate(moment(due).toDate(), complete)
        else if _hasAdvancedChecklists
          # Beta only embeds a date (no time/timezone) in the checkItem text.
          # Add one day so it appears overdue at 11:59pm that day in the viewing
          # user's timezone. V2 just relies on the server-side timestamp.
          DueDateHelpers.classForDueDate(moment(due).add(1, 'days').toDate(), complete)
      else
        ""

    $due.html(dueTemplate(dueText, className, @model.editable(), _hasAdvancedChecklists, @_hasUpsell()))
    .toggleClass('unset', !due)

    @$el.toggleClass('no-due', !due)

    return

  renderState: (e) ->
    data = @model.toJSON()
    data.checked = (data.state == 'complete')
    @$el.toggleClass('checklist-item-state-complete', data.checked)
    return

  toggleState: (e) ->
    return if !@model.editable()

    isComplete = @model.get('state') == 'complete'

    newState = if isComplete then 'incomplete' else 'complete'

    if newState == 'complete'
      @$el.addClass('checklist-item-fade-out')

      @setTimeout =>
        @model.update('state', newState)
        @$el.removeClass('checklist-item-fade-out')
      , 200

    else
      @$el.removeClass('checklist-item-fade-out')
      @model.update('state', newState)

    track("Checklist", "Toggle Checklist Item State", newState)

    return

  moveCheckItem: (e, ui, checklist, toDifferentChecklist) ->
    if !toDifferentChecklist && @model.getChecklist() != checklist
      # We've already handled this as a move to a different checklist
      return

    checkItems = ui.item.parent().children()
    index = checkItems.index(ui.item)
    pos = checklist.calcPos(index, @model)

    if toDifferentChecklist
      @model.update { pos, idChecklist: checklist.id }
      @model.collection.remove(@model)
      checklist.checkItemList.add(@model)
    else
      @model.update('pos', pos)

    checklist.checkItemList.sort({ silent: true })

    track("Checklist", "Reorder Checklist Item")

  commitEdits: (e) ->
    PopOver.hide()
    if @$('.js-checkitem-input').val().length == 0
      @model.destroy()
    else
      prevName = @model.get('name')
      super
      trackNameChange(@advancedCheckItemFromModel(), prevName, 'by clicking save button in edit checkitem view')

  _setName: (newName, trackingMethod) ->
    prevName = @model.get('name')

    if newName.length == 0
      @model.destroy()
      trackUe('card detail', 'removes', 'checklist item', '', '', trackingMethod)
    else
      # Update the textarea value as well, so that we don't save a draft
      # of the old value.
      textarea = @$('.field')
      if textarea?.val() == prevName
        textarea?.val(newName)

      @model.update('name', newName)
      trackNameChange(@advancedCheckItemFromModel(), prevName, trackingMethod)

  _setDue: (date) ->
    prevDate = @model.get('due')

    @model.update('due', date)

    acItem = @advancedCheckItemFromModel()
    name = @model.get('name')
    if endsWithDate(name)
      @_setName(name.replace(/\s+\d\d\d\d-\d\d-\d\d$/, ''), 'by choosing a value that conflicts with the value in the name')

    verb =
      if !prevDate && date
        'adds'
      else if !date && prevDate
        'removes'
      else
        'changes'
    trackUe('card detail', verb, 'due date', 'on checkitem', '', 'by clicking a submit button in due date picker')

  _setMember: (idMember) ->
    prevMember = @model.get('idMember')

    @model.update('idMember', idMember)

    if !idMember
      name = @model.get('name')
      if startsWithMention(name)
        @_setName(" #{ name }", 'by choosing a value that conflicts with the value in the name')

    verb =
      if !prevMember && idMember
        'adds'
      else if !idMember && prevMember
        'removes'
      else
        'changes'
    trackUe('card detail', verb, 'member', 'on checkitem', '', 'by clicking a submit button in member picker')

  openMenu: (e) ->
    Util.stop(e)

    PopOver.toggle
      elem: e.target
      view: CheckItemMenuView
      options: { @model, @modelCache }
      keepEdits: true
